import { useContext } from 'react';

import { BreakpointContext, type BreakpointProviderType } from './BreakpointProvider';

export const useBreakpoint = (): BreakpointProviderType => {
  const ctx = useContext(BreakpointContext);
  // oxlint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (ctx === undefined) {
    throw new Error('useBreakpoint used outside of ContextProvider!');
  } else {
    return ctx;
  }
};
